<template>
    <div class="personal-detail">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="320px" class="demo-ruleForm" style="width:800px;">
            <el-form-item label="Gender :" prop="gender">
                <el-select v-model="ruleForm.gender" placeholder="Please Select" style="width:100%">
                    <el-option  :value="Number(key)" :label="val" v-for="(val,key) in fieldOptions.gender"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Title :" prop="title">
                <el-select v-model="ruleForm.title" placeholder="Please Select" style="width:100%">
                   <el-option  :value="key" :label="val" v-for="(val,key) in fieldOptions.title"></el-option>
                </el-select>
            </el-form-item>

            <template v-if="fieldOptions.title">
                <el-form-item  label="Other" prop="other_title" v-if="( Object.keys(fieldOptions.title).indexOf(ruleForm.title) ===
                -1 &&
              ruleForm.title !== '')||ruleForm.title==='Other'" >
                  <el-input v-model="ruleForm.other_title"></el-input>
              </el-form-item>
            </template>


            <el-form-item label="First Name :" required>
                <el-col :span="9">
                  <el-form-item  prop="first_name" >
                    <el-input v-model="ruleForm.first_name"></el-input>
                  </el-form-item>
                </el-col>
                <el-col class="line" :span="1"> &nbsp;</el-col>
                <el-col class="line" :span="5"> Middle Name :</el-col>
                <el-col :span="9">
                  <el-form-item  >
                    <el-input v-model="ruleForm.middle_name" placeholder="optional"></el-input>
                  </el-form-item>
                </el-col>
            </el-form-item>

            <el-form-item  label="Last Name :" prop="last_name" >
                <el-input v-model="ruleForm.last_name"></el-input>
            </el-form-item>

            <el-form-item  label="Full  Name :" prop="full_name" >
                <el-input v-model="ruleForm.full_name" placeholder="Full Name in own language"></el-input>
            </el-form-item>

            <el-form-item label="Date of Birth :" required>
                <el-col :span="7">
                    <el-form-item prop="birth_day">
                        <el-select v-model="ruleForm.birth_day" placeholder="Day">
                             <el-option  :value="val" :label="val" v-for="(val,key) in 31"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col class="line" :span="1"> &nbsp;</el-col>
                <el-col :span="7">
                   <el-form-item prop="birth_month">
                        <el-select v-model="ruleForm.birth_month" placeholder="Month">
                             <el-option  :value="val" :label="val" v-for="(val,key) in 12"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col class="line" :span="1"> &nbsp;</el-col>
                <el-col :span="8">
                   <el-form-item prop="birth_year">
                        <el-select v-model="ruleForm.birth_year" placeholder="Year">
                            <el-option  :value="val" :label="val" v-for="(val,key) in fieldOptions.birth_year"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-form-item>

            <el-form-item  label="Country of Residence :" prop="residence_country" >
                <el-select filterable v-model="ruleForm.residence_country" placeholder="Please Select" style="width:100%">
                   <!-- <el-option  :value="val.name" :label="val.name" v-for="(val,key) in fieldOptions.country"></el-option> -->
                   <el-option
                      v-for="(item,index) in country_list"
                      :value="item.code"
                      :label="item.label" 
                      :key="index"
                      > </el-option>
                </el-select>
            </el-form-item>

            <el-form-item  label="House Name / Number :" prop="house_name" >
                <el-input v-model="ruleForm.house_name"></el-input>
            </el-form-item>

            <el-form-item  label="Street Name :" prop="street_name" >
                <el-input v-model="ruleForm.street_name"></el-input>
            </el-form-item>

            <el-form-item  label="City :" prop="city" >
                <el-input v-model="ruleForm.city"></el-input>
            </el-form-item>

            <el-form-item  label="County / State :" prop="state" >
                <el-input v-model="ruleForm.state"></el-input>
            </el-form-item>

            <el-form-item  label="Postcode / Zip :" prop="zip_code" >
                <el-input v-model="ruleForm.zip_code"></el-input>
            </el-form-item>

            <el-form-item label=" " prop="is_permanent_residence">
               <p>How long have you lived at this address?</p>
                <el-radio-group v-model="ruleForm.is_permanent_residence">
                    <el-radio :label="2">Less than 6 months</el-radio>
                    <el-radio :label="1">Longer than 6 months</el-radio>
                </el-radio-group>
            </el-form-item>

            <template v-if="Number(ruleForm.is_permanent_residence)===2">
              <el-form-item  label="Country of Residence :" prop="other_residence_country" >
                <el-select filterable v-model="ruleForm.other_residence_country" placeholder="Please Select">
                   <!-- <el-option  :value="val.name" :label="val.name" v-for="(val,key) in country"></el-option> -->
                   <el-option
                    v-for="(item,index) in country_list"
                    :value="item.code"
                    :label="item.label" 
                    :key="index"
                    > </el-option>
                </el-select>
              </el-form-item>

              <el-form-item  label="House Name / Number :" prop="other_house_name" >
                  <el-input v-model="ruleForm.other_house_name"></el-input>
              </el-form-item>

              <el-form-item  label="Street Name :" prop="other_street_name" >
                  <el-input v-model="ruleForm.other_street_name"></el-input>
              </el-form-item>

              <el-form-item  label="City :" prop="other_city" >
                  <el-input v-model="ruleForm.other_city"></el-input>
              </el-form-item>

              <el-form-item  label="County / State :" prop="other_state" >
                  <el-input v-model="ruleForm.other_state"></el-input>
              </el-form-item>

              <el-form-item  label="Postcode / Zip :" prop="other_zip_code" >
                  <el-input v-model="ruleForm.other_zip_code"></el-input>
              </el-form-item>
            </template>


           <el-form-item  label="National ID/Passport Number :" prop="passport_number" >
                <el-input v-model="ruleForm.passport_number"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button @click="resetForm('ruleForm')"  class="box-btn-default" style="width: 211px;">BACK</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')" :loading="btn_loading" class="box-btn"  style="width: 221px;">NEXT</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import * as server from '../action'
import _country_list from 'utils/country'
export default {
  data() {
    return {
      country_list: _country_list,
      fieldOptions: {},
      ruleForm: {
        gender: '',
        title: '',
        other_title: '',
        first_name: '',
        middle_name: '',
        last_name: '',
        full_name: '',
        birth_day: '',
        birth_month: '',
        birth_year: '',
        residence_country: '',
        house_name: '',
        street_name: '',
        city: '',
        state: '',
        zip_code: '',
        is_permanent_residence: '',
        other_residence_country: '',
        other_house_name: '',
        other_street_name: '',
        other_city: '',
        other_state: '',
        other_zip_code: '',
        passport_number: ''
      },
      rules: {
        gender: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        title: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        other_title: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        first_name: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        middle_name: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        last_name: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        full_name: [
          {
            required: true,
            message: 'Full Name in own language',
            trigger: 'blur'
          }
        ],
        birth_day: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        birth_month: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        birth_year: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        residence_country: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        house_name: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        street_name: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        city: [{ required: true, message: 'Please Enter', trigger: 'blur' }],
        state: [{ required: true, message: 'Please Enter', trigger: 'blur' }],
        zip_code: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        is_permanent_residence: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        other_residence_country: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        other_house_name: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        other_street_name: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        other_city: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        other_state: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        other_zip_code: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ],
        passport_number: [
          { required: true, message: 'Please Enter', trigger: 'blur' }
        ]
      },
      btn_loading: false
    }
  },
  created() {
    server.certification_apply_index({ step: 2 }).then(res => {
      this.fieldOptions = res.fieldOptions
      console.log('res.fieldOptions', JSON.stringify(res.fieldOptions.country))
      Object.keys(this.ruleForm).map((val, key) => {
        if (val === 'title') {
          if (
            Object.keys(res.fieldOptions.title).indexOf(res.setting[val]) ===
              -1 &&
            res.setting[val].length !== 0 &&
            res.setting[val]
          ) {
            this.ruleForm.other_title = res.setting['title']
            console.log('66666666666667', this.ruleForm.other_title)
            this.ruleForm.title = 'Other'
          } else {
            this.ruleForm.title = res.setting['title'] || ''
          }
        } else if (val !== 'other_title') {
          this.ruleForm[val] = res.setting[val] || ''
        }
      })
    })
  },
  methods: {
    submitForm(formName) {
      /* this.$emit('onStopIndex', 3) */
      this.btn_loading = true
      this.$refs[formName].validate(valid => {
        if (valid) {
          let title = ''
          if (this.ruleForm.title === 'Other') {
            title = this.ruleForm.other_title
          } else {
            title = this.ruleForm.title
          }

          if (Number(this.ruleForm.is_permanent_residence) === 1) {
            this.ruleForm.other_residence_country = ''
            this.ruleForm.other_house_name = ''
            this.ruleForm.other_street_name = ''
            this.ruleForm.other_city = ''
            this.ruleForm.other_state = ''
            this.ruleForm.other_zip_code = ''
          }
          let params = {
            ...this.ruleForm,
            step: 2,
            title
          }
          server
            .certification_apply_save(params)
            .then(res => {
              this.$emit('onStopIndex', 3)
              this.btn_loading = false
            })
            .catch(err => {
              this.btn_loading = false
            })
        } else {
          this.btn_loading = false
          return false
        }
      })
    },
    resetForm(formName) {
      this.$emit('onStopIndex', 1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.select-trading-account {
}
</style>
